import CorreiosPage from "./Correios";
export default CorreiosPage;
export { default as CorreiosPage } from './Correios';